import * as actions from './actions'
import { BasicAlertModalActions } from './actions'
import { alertsOrigin, BasicAlertModalState } from './model'
import { environmentSelectorReducer } from '../../../../common/environment/reducer'
import { resourceSelectorInitialState, resourceSelectorReducer } from '../../../../common/resource/reducer'
import { apiPolicySelectorInitialState, apiPolicySelectorReducer } from '../../../../common/policies/reducer'
import { selectorInitialState } from '../../../../common/redux/selector/reducerFor'
import { versionSelectorReducer } from '../../../../common/version/reducer'

const initialState: BasicAlertModalState = {
  isBasicAlertModalOpened: false,
  apiResponseCodesLimit: 10,
  existingAlert: undefined,
  serversLoading: false,
  servers: [],
  users: [],
  environmentSelector: selectorInitialState,
  resourceSelector: resourceSelectorInitialState,
  versionSelector: selectorInitialState,
  policySelector: apiPolicySelectorInitialState,
  serverApplications: [],
}

const environmentAlertsReducer = environmentSelectorReducer(alertsOrigin)
const resourceAlertsReducer = resourceSelectorReducer(alertsOrigin)
const versionAlertsReducer = versionSelectorReducer(alertsOrigin)
const policyAlertsReducer = apiPolicySelectorReducer(alertsOrigin)

const reducer = (state: BasicAlertModalState = initialState, action: BasicAlertModalActions): BasicAlertModalState => {
  state = {
    ...state,
    environmentSelector: environmentAlertsReducer(state.environmentSelector, action),
    resourceSelector: resourceAlertsReducer(state.resourceSelector, action),
    versionSelector: versionAlertsReducer(state.versionSelector, action),
    policySelector: policyAlertsReducer(state.policySelector, action),
  }

  switch (action.type) {
    case actions.HandleOpenModal:
      return {
        ...state,
        isBasicAlertModalOpened: true
      }
    case actions.HandleCloseModal:
      return {
        ...state,
        isBasicAlertModalOpened: false,
        resourceSelector: resourceSelectorInitialState,
      }
    case actions.CleanResourcesSelectors:
      return {
        ...state,
        servers: [],
        resourceSelector: resourceSelectorInitialState,
        versionSelector: {...state.versionSelector, selected: undefined}
      }
    case actions.ChangeExistingAlert:
      return {
        ...state,
        existingAlert: action.payload.basicAlert
      }
    case actions.FetchServers:
      return {
        ...state,
        serversLoading: true,
        servers: []
      }
    case actions.ChangeServers:
      return {
        ...state,
        serversLoading: false,
        servers: action.payload.servers
      }
    case actions.ChangeUsers:
      return {
        ...state,
        users: action.payload.users
      }

    case actions.ChangeAPIResponseCodesLimit:
      return {
        ...state,
        apiResponseCodesLimit: action.payload.apiResponseCodesLimit
      }
    default:
      return state
  }
}

export default reducer
